import { GLContext } from 'nanogl/types'

import FontAtlas from '@/webgl/engine/FontAtlas'
import { AtlasData } from '@/webgl/engine/FontAtlas.types'
import AssetDatabase from '@/webgl/resources/AssetDatabase'
import { JsonResource } from '@/webgl/resources/Net'
import { Resource } from '@/webgl/resources/Resource'

export default class FontAtlasResource extends Resource<FontAtlas> {
  constructor(
    readonly path: string,
    readonly gl: GLContext
  ) {
    super()
  }

  async doLoad(): Promise<FontAtlas> {
    const texture = await AssetDatabase.getTexture(this.path + '.png', this.gl, { alpha: true }).load()
    const data: AtlasData = await new JsonResource(AssetDatabase.getAssetPath(this.path + '.json')).load()

    return new FontAtlas(texture, data)
  }

  doUnload(): void {}
}
